import React from 'react';
import FilterModel from 'app/components/FilterModel';

const CollectPrivilege = ({
  values,
  setValues,
  isFilterOpen,
  setIsFilterOpen,
  onSubmit,
}) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    if (form.checkValidity()) {
      onSubmit({ values });
    } else {
      form.reportValidity();
    }
  };

  const handleCancel = () => {
    setIsFilterOpen(false);
  };
  const resetfilter = () => {};
  return (
    <>
      {isFilterOpen && (
        <FilterModel
          isFilterOpen={isFilterOpen}
          setIsFilterOpen={setIsFilterOpen}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          resetfilter={resetfilter}
          filter={false}
          heading='Collect Privilege'
        >
          <>
            <div className='offcanvas-item'>
              <label>Phone Number:</label>
              <input
                required
                type='number'
                value={values?.phoneNumber}
                disabled={true}
              />
            </div>
            <div className='offcanvas-item'>
              <label>Select Privilege</label>
              <input type='text' value={values?.privilege} disabled={true} />
            </div>
          </>
        </FilterModel>
      )}
    </>
  );
};

export default CollectPrivilege;
